import React, { Component } from 'react'
import { Button, TableCell, TableRow, } from "@mui/material";
import { Col, Container, Row, Form, Modal } from 'react-bootstrap';
import Select from '../../Components/PCSelect';
import axios from "axios";
import ReactToPrint from 'react-to-print';
import Bardcode from '../../Components/JobForm/Bardcode';
import Swal from "sweetalert2";
import PhoneClinicGrid from '../../Components/PhoneClinicGrid';
import RowActions from '../../Components/PhoneClinicGrid/RowActions';
import { moneyCell } from '../../helper';

import AmountInput from '../../Components/AmountInput';
import OwnEntityField from '../../Components/OwnEntityField';
import { defaultOwnId } from '../../helper/identity';

const OWN_SCREEN = '/admin/items';
class Items extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // The working shop (Phase 2): the list shows it and new records are saved to it.
            OWN_ID: defaultOwnId('shop', OWN_SCREEN),
            showModal: false,
            InventoryList: [],
            ITEM_ID: "",
            ITEM_NAME: "",
            ITEM_CATEGORY: "",
            ITEM_DEVICE: "",
            ITEM_MODEL: "",
            ITEM_DESC: "",
            ITEM_BRAND: {},
            ITEM_BARCODE: "",
            ITEM_BUY_RATE: "",
            ITEM_SELL_RATE: "",
            ITEM_QUANTITY: "",


            width: 1,
            height: 60,
            displayValue: true,
            text: "",
            fontOptions: "",
            font: "monospace",
            textAlign: "center",
            textPosition: "bottom",
            textMargin: 0,
            fontSize: 15,
            background: "#ffffff",
            lineColor: "#000000",
            margin: 10,
            marginTop: 0,
            marginBottom: 0,
            marginLeft: 0,
            marginRight: 0,


            DeviceList: [],
            CategoryList: []

        }
        this.gridRef = React.createRef(null);
    }

    /* ── Working shop (Phase 2, 2026-11-02): a user with several shops picks it at the top. ── */
    ownId() {
        return this.state.OWN_ID || localStorage.getItem('PC_GRP_ATT') || '';
    }

    handleOwnChange(id) {
        this.setState({ OWN_ID: String(id) }, () => this.getInventory());
    }

    async getInventory(searchData = [], pagination = { recordOffset: 1, pageSize: 50 }) {
        this.props.toggleLoader(true)
        let formData = {
            PC_SP_ID: this.ownId() || 0,
            searchData,
            pageSize: pagination.pageSize,
            recordOffset: pagination.recordOffset
        };
        const getAllInventory = await axios.post(`${process.env.REACT_APP_BASE_URL}services/query/PCGetAllInventory.php`, formData);
        let serviceData = getAllInventory.data
        let InventoryList = []
        if (serviceData.success === 1) {
            InventoryList = serviceData.data
            pagination.totalItems = parseInt(serviceData.Page_count[0]['TOTAL_PAGE_COUNT'])
            pagination.totalPages = Math.ceil(pagination.totalItems / pagination.pageSize || 50)
            this.gridRef.current?.setPaginationData(pagination)
        }
        this.setState({ InventoryList })
        this.props.toggleLoader(false)
    }

    handleEdit(indx) {
        let { InventoryList } = this.state;
        let FilteredData = InventoryList[indx];

        this.setState({
            showModal: true,
            ITEM_ID: FilteredData.INV_ID,
            ITEM_NAME: FilteredData.INV_ITEM_NAME,
            ITEM_CATEGORY: { value: FilteredData.INV_CATEGORY, label: FilteredData.INV_CATEGORY },
            ITEM_DEVICE: { value: FilteredData.DEVICE_ID, label: FilteredData.DEVICE_ID },
            ITEM_MODEL: FilteredData.INV_MODEL,
            ITEM_DESC: FilteredData.INV_DESC,
            ITEM_BARCODE: FilteredData.INV_BARCODE,
            ITEM_BUY_RATE: FilteredData.PC_ITEM_BUY_RATE,
            ITEM_SELL_RATE: FilteredData.PC_ITEM_SELL_RATE,
            ITEM_QUANTITY: FilteredData.PC_ITEM_QUANTITY
        })
    }

    hanldeAddInventory() {
        this.setState({ showModal: true })
    }

    handleChange(name, evt) {
        switch (name) {
            case "ITEM_CATEGORY":
            case "ITEM_BRAND":
                this.setState({ [name]: evt })
                break;

            default:
                this.setState({ [name]: evt.target.value })
                break;
        }
    }

    ValidateInvoice() {
        if (this.state.ITEM_NAME === "") {
            Swal.fire(
                'Error',
                "Enter Item Name",
                'error'
            )
            return false
        }
        // if (this.state.ITEM_MODEL === "") {
        //     Swal.fire(
        //         'Error',
        //         "Enter Item Model",
        //         'error'
        //     )
        //     return false
        // }
        if (this.state.ITEM_BARCODE === "") {
            Swal.fire(
                'Error',
                "Enter Item Barcode",
                'error'
            )
            return false
        }

        return true
    }

    async handleSave() {
        if (!this.ValidateInvoice()) return
        let FormData = {
            ITEM_ID: this.state.ITEM_ID,
            ITEM_BUY_RATE: this.state.ITEM_BUY_RATE || "0",
            ITEM_SELL_RATE: this.state.ITEM_SELL_RATE || "0",
            ITEM_QUANTITY: this.state.ITEM_QUANTITY || "0",
            ITEM_SHOP_ID: this.ownId()
        }

        let ReturnDataResult = await axios.post(`${process.env.REACT_APP_BASE_URL}services/mutation/PCAddInventory.php`, FormData);
        if (ReturnDataResult.data.status === 200) {
            Swal.fire(
                'Success',
                ReturnDataResult.data.message,
                'success'
            )
        } else {
            Swal.fire(
                'Error',
                ReturnDataResult.data.message,
                'error'
            )
        }
        this.setState({ showModal: false })
        this.getInventory()
    }

    handleCancel() {
        this.getInventory()

        this.setState({
            showModal: false,
            ITEM_ID: "",
            ITEM_NAME: "",
            ITEM_CATEGORY: {},
            ITEM_MODEL: "",
            ITEM_DESC: "",
            ITEM_BRAND: {},
            ITEM_BARCODE: "",
            ITEM_BUY_RATE: "",
            ITEM_SELL_RATE: "",
            ITEM_QUANTITY: "",
            searchGridData: ""
        })
    }

    render() {
        return (
            <Container>
                <OwnEntityField compact kind={'shop'} screen={OWN_SCREEN} value={this.ownId()} onChange={this.handleOwnChange.bind(this)} />
                <PhoneClinicGrid
                    title="ITEM"
                    buttonLabel=""
                    onClickButton={() => { }}
                    getData={this.getInventory.bind(this)}
                    isEditable={true}
                    ref={this.gridRef}
                    tableHeadData={[
                        { label: "ITEM", isHidden: false },
                        { label: "BRAND", isHidden: false },
                        { label: "CATEGORY", isHidden: false },
                        { label: "BARCODE", isHidden: false },
                        { label: "BUY RATE", isHidden: false, align: 'right' },
                        { label: "SALE RATE", isHidden: false, align: 'right' },
                        { label: "QUANTITY", isHidden: false },
                    ]}
                >
                    {this.state.InventoryList.map((service, idx) => (
                        <TableRow
                            key={idx}
                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                            style={{ whiteSpace: 'nowrap' }}
                        >
                            <TableCell>{service.INV_ITEM_NAME}</TableCell>
                            <TableCell>{service.DEVICE_ID}</TableCell>
                            <TableCell>{service.INV_CATEGORY}</TableCell>
                            <TableCell>{service.INV_BARCODE}</TableCell>
                            <TableCell align="right"><strong>{moneyCell(service.PC_ITEM_BUY_RATE)}</strong></TableCell>
                            <TableCell align="right"><strong>{moneyCell(service.PC_ITEM_SELL_RATE)}</strong></TableCell>
                            <TableCell>{service.PC_ITEM_QUANTITY}</TableCell>
                            <TableCell align='center'>
                                <RowActions actions={[
                                    { type: 'edit', onClick: this.handleEdit.bind(this, idx) },
                                ]} />
                            </TableCell>
                        </TableRow>
                    ))}

                </PhoneClinicGrid>


                <Modal
                    show={this.state.showModal}
                    onHide={() => { this.setState({ showModal: false }) }}
                    size="lg"
                >
                    <Modal.Header closeButton>
                        <Modal.Title>
                            Inventory
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Row style={{ margin: "5px" }} >
                            <Col md={6}>
                                <Form.Group className="mb-3" >
                                    <Form.Label>Item</Form.Label>
                                    <span style={{ color: 'red', marginLeft: '15px' }} >{'*'}</span>
                                    <Form.Control
                                       
                                        name="ITEM_NAME"
                                        disabled
                                        value={this.state.ITEM_NAME}
                                        onChange={this.handleChange.bind(this, 'ITEM_NAME')}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={4}>
                                <Form.Group className="mb-3" >
                                    <Form.Label>Brand</Form.Label>
                                    <span style={{ color: 'red', marginLeft: '15px' }} >{'*'}</span>
                                    <Select menuPortalTarget={document.body}
                                        // menuPlacement="auto"
                                        isDisabled
                                        style={{ height: '32px' }}
                                        name="ITEM_DEVICE"
                                        value={this.state.ITEM_DEVICE}
                                        options={[]}
                                        onChange={this.handleChange.bind(this, 'ITEM_DEVICE')}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={4}>
                                <Form.Group className="mb-3" >
                                    <Form.Label>Category</Form.Label>
                                    <span style={{ color: 'red', marginLeft: '15px' }} >{'*'}</span>
                                    <Select menuPortalTarget={document.body}
                                        // menuPlacement="auto"
                                        isDisabled
                                        style={{ height: '32px' }}
                                        name="ITEM_CATEGORY"
                                        value={this.state.ITEM_CATEGORY}
                                        options={[]}
                                        onChange={this.handleChange.bind(this, 'ITEM_CATEGORY')}
                                    />
                                </Form.Group>
                            </Col>
                            {/* <Col md={6}>
                                <Form.Group className="mb-3" >
                                    <Form.Label>Model</Form.Label>
                                    <span style={{ color: 'red', marginLeft: '15px' }} >{'*'}</span>
                                    <Form.Control
                                        style={{ height: '32px' }}
                                        disabled
                                        name="ITEM_MODEL"
                                        value={this.state.ITEM_MODEL}
                                        onChange={this.handleChange.bind(this, 'ITEM_MODEL')}
                                    />
                                </Form.Group>
                            </Col> */}
                            <Col md={6}>
                                <Form.Group className="mb-3" >
                                    <Form.Label>Barcode</Form.Label>
                                    <span style={{ color: 'red', marginLeft: '15px' }} >{'*'}</span>
                                    <Form.Control
                                        disabled
                                       
                                        name="ITEM_BARCODE"
                                        value={this.state.ITEM_BARCODE}
                                        onChange={this.handleChange.bind(this, 'ITEM_BARCODE')}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={4}>
                                <Form.Group className="mb-3" >
                                    <Form.Label>Buying Rate</Form.Label>
                                    <span style={{ color: 'red', marginLeft: '15px' }} >{'*'}</span>
                                    <AmountInput
                                       
                                        name="ITEM_BUY_RATE"
                                        value={this.state.ITEM_BUY_RATE}
                                        onChange={this.handleChange.bind(this, 'ITEM_BUY_RATE')}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={4}>
                                <Form.Group className="mb-3" >
                                    <Form.Label>Selling Rate</Form.Label>
                                    <span style={{ color: 'red', marginLeft: '15px' }} >{'*'}</span>
                                    <AmountInput
                                        name="ITEM_SELL_RATE"
                                        value={this.state.ITEM_SELL_RATE}
                                        onChange={this.handleChange.bind(this, 'ITEM_SELL_RATE')}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={4}>
                                <Form.Group className="mb-3" >
                                    <Form.Label>Quantity</Form.Label>
                                    <span style={{ color: 'red', marginLeft: '15px' }} >{'*'}</span>
                                    <Form.Control
                                       
                                        type={"number"}
                                        name="ITEM_QUANTITY"
                                        value={this.state.ITEM_QUANTITY}
                                        onChange={this.handleChange.bind(this, 'ITEM_QUANTITY')}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={12}>
                                <Form.Group className="mb-3" >
                                    <Form.Label>Description</Form.Label>
                                    <Form.Control
                                       
                                        disabled
                                        type={"textarea"}
                                        name="ITEM_DESC"
                                        value={this.state.ITEM_DESC}
                                        onChange={this.handleChange.bind(this, 'ITEM_DESC')}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={12}>
                                {/* <Form.Label>Barcode IMEI</Form.Label> */}
                                <div ref={el => (this.printLabel = el)} >
                                    <Bardcode
                                        value={this.state.ITEM_BARCODE || "00000"}
                                        width={this.state.width}
                                        height={this.state.height}
                                        displayValue={this.state.displayValue}
                                        text={this.state.text}
                                        fontOptions={this.state.fontOptions}
                                        font={this.state.font}
                                        textAlign={this.state.textAlign}
                                        textPosition={this.state.textPosition}
                                        textMargin={this.state.textMargin}
                                        fontSize={this.state.fontSize}
                                        background={this.state.background}
                                        lineColor={this.state.lineColor}
                                        margin={this.state.margin}
                                        marginTop={this.state.marginTop}
                                        marginBottom={this.state.marginBottom}
                                        marginLeft={this.state.marginLeft}
                                        marginRight={this.state.marginRight}
                                    />
                                </div>
                            </Col>
                        </Row>
                    </Modal.Body>
                    <Modal.Footer>

                        <ReactToPrint
                            trigger={() => { return <Button>Print Barcode</Button>; }}
                            content={() => this.printLabel}
                        />

                        <Button onClick={this.handleCancel.bind(this)}>Cancel</Button>
                        <Button onClick={this.handleSave.bind(this)} >Save</Button>

                    </Modal.Footer>
                </Modal>

            </Container >
        );
    }
}

export default Items;